import { z } from 'zod';

/**
 * Phase ② LegalPlanner — output `qualification`.
 *
 * Identifie 5-10 thèmes juridiques sur-générés (entonnoir D26). Pas encore
 * d'arguments — juste le découpage en thèmes + leur application à l'espèce.
 *
 * Voir hub doc § 4 ② (`docs/architecture/plan-detaille-v2.md`).
 */

export const CaseAnalysisSchema = z.object({
  legal_matters: z.array(z.string()),
  legal_specialization: z.string(),
  client_position: z.string(),
  client_concerns: z.array(z.string()),
  overall_confidence: z.number().min(0).max(1),
}).strict();
export type CaseAnalysis = z.infer<typeof CaseAnalysisSchema>;

export const ThemeJuridiqueSchema = z.object({
  id: z.string(),                                  // 'theme-1', 'theme-2', ...
  libelle: z.string(),                             // libellé détaillé (pas un titre court)
  regime_juridique: z.string(),
  description_theme: z.string(),                   // contexte, cadre, principes
  application_a_lespece: z.string(),               // texte rédigé : faits subsumés
  codes_a_interroger: z.array(z.string()),         // ex: ["Code civil"] — indicatif
}).strict();
export type ThemeJuridique = z.infer<typeof ThemeJuridiqueSchema>;

export const QualificationSchema = z.object({
  case_analysis: CaseAnalysisSchema,
  themes_juridiques: z.array(ThemeJuridiqueSchema).min(1),
}).strict();
export type Qualification = z.infer<typeof QualificationSchema>;
